<template>
  <footer class="px-3 sm:px-6 flex gap-3 justify-end border-t border-t-gray-200 py-3 sm:py-4">
    <slot />
  </footer>
</template>
